import Tooltip from "@material-ui/core/Tooltip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import size from "lodash/size";
import React from "react";
import { useSelector } from "react-redux";

import DropdownSelect from "../../forms/custom/DropdownSelect";

function LabelTooltip() {
  return (
    <Tooltip
      placement="right"
      title="If you do not see the correct Cost Center, add it from your Invoice Settings. Cost Centers are required to mark a hire."
    >
      <label style={{ width: "fit-content" }}>
        <span style={{ display: "flex", alignItems: "center" }}>
          Cost Center
          <InfoOutlinedIcon
            style={{
              color: "#90A4AE",
              fontSize: 16,
              paddingLeft: 4,
            }}
          />
        </span>
      </label>
    </Tooltip>
  );
}

function CostCenterDropdown({
  disabled,
  error,
  helperText,
  id,
  onChange,
  onBlur,
  value,
  style,
}) {
  const costCenters = useSelector((state) => state.costCenters.items);
  const isVisible = size(costCenters) > 1;
  const costcenterOptions = orderBy(
    map(costCenters, ({ attributes: { id, name } }) => ({
      label: name,
      value: id,
    })),
    ({ label }) => label.toLowerCase()
  );

  // Wrap onChange to maintain backward compatibility with event-based handlers
  const handleChange = (selectedOption) => {
    // Create a synthetic event-like object to maintain compatibility
    const syntheticEvent = {
      currentTarget: {
        value: selectedOption ? selectedOption.value : '',
        name: id,
        id: id,
      },
      target: {
        value: selectedOption ? selectedOption.value : '',
        name: id,
        id: id,
      },
    };
    onChange(syntheticEvent);
  };

  // Find the selected option object for DropdownSelect
  // Convert both values to strings for comparison to handle type mismatches
  const selectedValue = costcenterOptions.find(option => 
    String(option.value) === String(value)
  ) || null;

  return isVisible ? (
    <DropdownSelect
      style={style}
      isClearable={true}
      disabled={disabled}
      error={error}
      helperText={helperText}
      id={id}
      label={<LabelTooltip />}
      onChange={handleChange}
      onBlur={onBlur}
      options={costcenterOptions}
      value={selectedValue}
    />
  ) : (
    <></>
  );
}

export default CostCenterDropdown;
